<template>
  <qx-card-form title="需求信息">
    <ChooseDriver
      ref="chooseDriver"
      :customShow="true"
      :resultVal="chooseDriver"
      @change="chooseDriverChange"
      :fnRadioDisabled="
          (item) => {
            return item.state !== 2;
          }
        "
      :otherSearchData="{carUserType:1,salaryPattern:5}"
    />
    <qx-custom-form
        :noSubBtn="true"
        ref="baseForm"
        :formData="baseForm"
        labelWidth="120px">
      <!-- 司机运价 -->
      <section slot="goodsPrice" slot-scope="prop">
        <el-input
            v-model="prop.form.goodsPrice"
            class="inputBox"
            placeholder="请填写司机的运费信息"
            @input="dealGoodsPrice"
        >
          <el-select
              class="inputAppendSelect"
              slot="suffix"
              v-model="otherFormData.goodsUnit"
              :clear="true"
          >
            <!-- 单位 -->
            <el-option
                v-for="item in goodsUnitOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-input>
      </section>
      <!--  发布范围 -->
      <section slot="releaseScope" slot-scope="prop">
        <el-radio-group v-model="prop.form.releaseScope" >
          <el-radio
              :label="item.value"
              v-for="(item, index) in baseForm.releaseScopeOptions"
              :key="index"
              @click.native="releaseScopeClick(item.value)"
          >{{ item.label }}</el-radio>
        </el-radio-group>
      </section>

    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import ChooseDriver from 'components/choose/driver';
import {dealNumber, dealZero} from '@qx/utils';
export default {
  components: {
    ChooseDriver,
  },
  data () {
    return {
      goodsUnitOptions: [
        {label: '元/车', value: '1'},
      ],
      otherFormData: {
        goodsUnit: '',
        id: '',
        updateType: null,
        orderId: '',
        chooseDriverInfo: '',
      },
      chooseDriver: {},
      baseForm: {
        dispatchMethodOptions: [], // 派车方式
        releaseScopeOptions: [], // 发布范围
        form: [
          {
            label: '派车方式',
            value: 'dispatchMethod',
            type: 'radio',
          },
          {
            label: '需求车次',
            value: 'requiredTrainNumber',
            type: 'input',
            onInput: (requiredTrainNumber) => {
              this.$refs.baseForm.setVal('requiredTrainNumber', dealZero(String(dealNumber(requiredTrainNumber, false)), false));
            },
          },
          {
            label: '司机运价',
            value: 'goodsPrice',
            slot: true,
          },
          {
            label: '联系人',
            value: 'contacts',
            placeholder: '请填写联系人姓名',
            type: 'input',
          },
          {
            label: '联系人电话',
            value: 'contactsPhone',
            placeholder: '请填写联系人电话',
            type: 'input',
          },
          {
            label: '发布范围',
            value: 'releaseScope',
            type: 'radio',
            slot: true,
          },
          {
            label: '截止时间',
            value: 'releaseDeadlineTime',
            type: 'date',
            attr: {
              type: 'datetime',
              time: '00:00:00',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
          },
        ],
        rules: {
          dispatchMethod: [
            { required: true, message: '请选择派车方式', trigger: 'blur' },
          ],
          requiredTrainNumber: [
            { required: true, message: '请输入需求车次', trigger: 'blur' },
            {validator: this.checkRequiredTrainNumber, trigger: 'blur'},
          ],
          goodsPrice: [
            { required: true, message: '请输入司机运价', trigger: 'blur' },
          ],
          contacts: [
            { required: true, message: '请输入联系人', trigger: 'blur' },
          ],
          contactsPhone: [
            { required: true, message: '请输入联系人电话', trigger: 'blur' },
            { validator: this.checkMobile, trigger: 'blur' },
          ],
          releaseScope: [
            { required: true, message: '请选择发布范围', trigger: 'blur' },
          ],
          releaseDeadlineTime: [
            { required: true, message: '请选择截止时间', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    releaseScopeClick (val) {
      if (val === '2') {
        this.$refs.chooseDriver.show();
      }
    },
    dealGoodsPrice (val) {
      this.$refs.baseForm.setVal('goodsPrice', dealNumber(val, false));
    },
    checkRequiredTrainNumber (rule, value, call) {
      if (String(value) === '0') {
        call('不可输入0');
      } else {
        call();
      }

    },
    async getDataTest () {
      const formData = await this.sub();
    },
    setList (options) {
      this.baseForm.dispatchMethodOptions = options[0];
      this.baseForm.releaseScopeOptions = options[1];
    },
    chooseDriverChange (selectedDriverInfo) {
      let userIdArr = [];
      if (selectedDriverInfo.length === 1) {
        userIdArr.push(selectedDriverInfo[0].userId);
      } else {
        selectedDriverInfo.map((item) => {
          userIdArr.push(item.userId || item.driverUserId);
        });
      }
      this.otherFormData.chooseDriverInfo = userIdArr;
      this.chooseDriver = selectedDriverInfo;
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        formData.releaseDeadlineTime = formData.releaseDeadlineTime ? this.formatDate(formData.releaseDeadlineTime, 1) : '';
        formData.releaseTime = this.formatDate(new Date(), 1); // 创建时间
        formData.driverTariff = JSON.stringify([Object.assign({goodsPrice: formData.goodsPrice}, {goodsUnit: this.goodsUnitOptions.filter((item) => item.value === this.otherFormData.goodsUnit)[0].label})]);
        if (formData.releaseScope === '2') {
          formData.driverIds = this.otherFormData.chooseDriverInfo.toString(',');
        } else {
          formData.driverIds = '';
        }
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData.chooseDriverInfo) {

        delete formData.chooseDriverInfo;
      }
      return formData;
    },
    setDetailData (data) {
      if (data.goodsUnit === undefined || data.goodsUnit === null) {
        data.goodsUnit = this.goodsUnitOptions[0].value;
      }
      if (data.dispatchMethod) {
        data.dispatchMethod = String(data.dispatchMethod);
      }
      if (data.releaseScope) {
        data.releaseScope = String(data.releaseScope);
      }
      if (data.orderGoodsDriverTariffs) {
        data.goodsPrice = data.orderGoodsDriverTariffs[0].goodsPriceDouble;
      }
      if (this.$route.query.id) {
        this.otherFormData.id = this.$route.query.id;
        this.otherFormData.updateType = 1;
      }
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      this.setDetailData(data);
      this.$refs.baseForm.setVal(data);
      if (data.dispatchMethod === undefined || data.dispatchMethod === null) {
        this.$refs.baseForm.setVal('dispatchMethod', '1');
      }
      this.setFormVal(this.otherFormData, data);
      this.otherFormData.orderId = data.rawOrderId;
      if (data.orderSourceDrivers) {
        let arr = [];
        data.orderSourceDrivers.map((item) => {
          arr.push(item.driverUserId);
        });
        this.otherFormData.chooseDriverInfo = arr;
        this.chooseDriver = data.orderSourceDrivers; // 修改时，选择司机默认选中已选过的信息
        this.chooseDriver.map((item, index) => {
          item.loginAcct = item.mobilePhone; // loginAcct是选择司机的列表唯一id
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
